import { render, staticRenderFns } from "./RemoveCourses.vue?vue&type=template&id=1cab1993&scoped=true&"
import script from "./RemoveCourses.vue?vue&type=script&lang=js&"
export * from "./RemoveCourses.vue?vue&type=script&lang=js&"
import style0 from "./RemoveCourses.vue?vue&type=style&index=0&id=1cab1993&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cab1993",
  null
  
)

export default component.exports